module.exports = new __parcel__URL__("integrations-darkmode.c1854228.svg").toString();